import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

interface ExportDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  allHeaders: string[];
  onExport: (selectedHeaders: string[]) => void;
}

export const ExportDialog: React.FC<ExportDialogProps> = ({ open, onOpenChange, allHeaders, onExport }) => {
  const [selectedHeaders, setSelectedHeaders] = useState<string[]>(allHeaders);

  useEffect(() => {
    setSelectedHeaders(allHeaders);
  }, [allHeaders]);

  const handleSelectAll = (checked: boolean) => {
    setSelectedHeaders(checked ? allHeaders : []);
  };

  const handleHeaderChange = (header: string, checked: boolean) => {
    setSelectedHeaders(prev => 
      checked ? [...prev, header] : prev.filter(h => h !== header)
    );
  };

  const handleExportClick = () => {
    onExport(selectedHeaders);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Seleccionar Columnas a Exportar</DialogTitle>
          <DialogDescription>
            Elige las columnas que quieres incluir en el archivo Excel.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
            <div className="flex items-center space-x-2">
                <Checkbox
                    id="select-all"
                    checked={selectedHeaders.length === allHeaders.length && allHeaders.length > 0}
                    onCheckedChange={handleSelectAll}
                />
                <Label htmlFor="select-all" className="font-bold">
                    Seleccionar Todo
                </Label>
            </div>
            <div className="grid grid-cols-2 gap-2 max-h-60 overflow-y-auto p-1 border rounded-md">
                {allHeaders.map(header => (
                    <div key={header} className="flex items-center space-x-2">
                        <Checkbox
                            id={header}
                            checked={selectedHeaders.includes(header)}
                            onCheckedChange={(checked) => handleHeaderChange(header, !!checked)}
                        />
                        <Label htmlFor={header}>{header}</Label>
                    </div>
                ))}
            </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={handleExportClick}>Exportar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
